import { useState, useEffect } from 'react';
import axios from 'axios';
import jsonData from '../components/ai-branding.json';

const getCurrentEdition = () => {
  const months = [
    "january", "february", "march", "april", "may", "june",
    "july", "august", "september", "october", "november", "december"
  ];
  const now = new Date();
  return `${months[now.getMonth()]}${now.getFullYear()}`;
};

export const useEditionData = (editionName) => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!editionName) {
      setLoading(false);
      setError(true);
      return;
    }

    const basePath = process.env.REACT_APP_MASTERMIND_EDITION_JSON_PATH
      || `${process.env.REACT_APP_CDN_LINK}mastermind/homepage/jsons/`;

    axios.get(`${basePath}${editionName}.json?t=${Date.now()}`)
      .then(res => {
        setPageData(res.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setError(true);
      });
  }, [editionName]);

  return { pageData, loading, error, setPageData };
};

export const useAiBrandingData = () => {
  const [aiBrandingData, setAiBrandingData] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_CDN_LINK}jsons/ai-branding.json?t=${Date.now()}`)
      .then(res => setAiBrandingData(res.data))
      .catch(() => setAiBrandingData(jsonData));
  }, []);

  return aiBrandingData;
};

export const useRedirectToCurrentEdition = (shouldRedirect, currentEditionName) => {
  useEffect(() => {
    if (!shouldRedirect) return;
    const targetEdition = getCurrentEdition();
    // If we're already on the current month edition and it failed, go to homepage
    if (currentEditionName === targetEdition) {
      window.location.replace('/masterminds/');
    } else {
      window.location.replace(`/masterminds/${targetEdition}`);
    }
  }, [shouldRedirect, currentEditionName]);
};

export const useRedirectToEdition = (shouldRedirect, editionName) => {
  useEffect(() => {
    if (!shouldRedirect) return;
    if (editionName) {
      window.location.replace(`/masterminds/${editionName}`);
    } else {
      window.location.replace(`/masterminds/${getCurrentEdition()}`);
    }
  }, [shouldRedirect, editionName]);
};
